const navLinks = {
  ROOT: '/communicationshub',
  COMMUNICATIONS_HUB_INBOX: '/communicationshub/inbox',
  COMMUNICATIONS_HUB_SETTINGS: '/communicationshub/settings'
};

export default navLinks;